































import { computed, defineComponent, ref } from "@vue/composition-api";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "MessageDeleteConfirm",
  components: { BaseConfirm, BaseButton },
  props: {
    message: { type: Object as () => Message | null },
    canDeleteForAll: { type: Boolean, default: false },
    canManageMessages: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const loading = ref(false);

    const deleteButtonText = computed(() => (props.canManageMessages ? $t("Delete for everyone") : $t("Delete")));

    const deleteMessage = async () => {
      if (!props.message) return;

      try {
        loading.value = true;
        await providers.MessagesProvider.delete({ data: { messageId: props.message.id } });
        emit("deleted");
      } finally {
        loading.value = false;
      }
    };

    const hideMessage = async () => {
      if (!props.message) return;

      try {
        loading.value = true;
        await providers.MessagesProvider.deleteForMe({ data: { messageId: props.message.id } });
        emit("deleted");
      } finally {
        loading.value = false;
      }
    };

    return { loading, deleteButtonText, deleteMessage, hideMessage };
  },
});
